import { StarRating } from '@nf/ui';
import { useFormContext } from 'react-hook-form';

interface StarRatingContainerProps {
	field : any;
    onRating?: (rating: number) => void;
    amount: number;
    iconType: string;
}
export const StarRatingContainer = ({ field, onRating, ...ratingProps }: StarRatingContainerProps) => {
	const { setValue } = useFormContext();

	const handleRating = (rating: number) => {
		setValue(field.name, rating, { shouldValidate: true });
		onRating && onRating(rating);
	};

	return (
		<>
			<StarRating 
				score={field.value}
				{...ratingProps}
				onRating={handleRating}				
			/>
			<input 
				type="number"
				{...field}
				hidden
				readOnly
				value={field.value}
			/>
		</>
	);
};